export const ISO_WEEKDAY_LABELS = Object.freeze({
  1: 'Monday',
  2: 'Tuesday',
  3: 'Wednesday',
  4: 'Thursday',
  5: 'Friday',
  6: 'Saturday',
  7: 'Sunday',
});

export function isIsoWeekday(value) {
  return Number.isInteger(value) && value >= 1 && value <= 7;
}

export function normalizeIsoWeekdays(nonBusinessDays) {
  return (Array.isArray(nonBusinessDays) ? nonBusinessDays : [])
    .map((day) => Number(day))
    .filter((day) => isIsoWeekday(day))
    .sort((a, b) => a - b);
}

export function getSelectedDays(nonBusinessDays, options = {}) {
  const selectedWeekdays = normalizeIsoWeekdays(nonBusinessDays);
  return selectedWeekdays.reduce((result, isoWeekDay) => {
    result[isoWeekDay] = true;
    return result;
  }, {});
}

export function getSelectedIsoWeekdays(selectedDays) {
  return Object.keys(selectedDays || {})
    .filter((day) => !!selectedDays[day])
    .map((day) => Number(day))
    .filter((day) => isIsoWeekday(day))
    .sort((a, b) => a - b);
}

export function formatNonBusinessDays(nonBusinessDays) {
  if (nonBusinessDays === null) {
    return 'Not configured';
  }

  const selectedWeekdays = normalizeIsoWeekdays(nonBusinessDays);
  if (selectedWeekdays.length === 0) {
    return 'None';
  }

  return selectedWeekdays.map((day) => ISO_WEEKDAY_LABELS[day]).join(', ');
}
